import { atom } from "jotai";

export enum SidebarState {
    CLOSED = "closed",
    LEFT_SIDEBAR = "left_sidebar",
    RIGHT_DRAWER = "right_drawer",
}

export enum RightDrawerSize {
    DEFAULT = "default",
    EXPANDED = "expanded",
}

export const parentSectionAtom = atom<string | null>(null);
export const showParentHeaderAtom = atom<boolean>(true);

export const sidebarStateAtom = atom<SidebarState>(SidebarState.LEFT_SIDEBAR);
export const rightDrawerSizeAtom = atom<RightDrawerSize>(
    RightDrawerSize.DEFAULT,
);
export const mobileRightDrawerOpenAtom = atom<boolean>(false);
export const showCompanyListAtom = atom<boolean>(false);

const previousSidebarStateAtom = atom<SidebarState>(SidebarState.LEFT_SIDEBAR);

export const sidebarOpenAtom = atom(
    (get) => get(sidebarStateAtom) === SidebarState.LEFT_SIDEBAR,
    (get, set, value: boolean) => {
        const currentState = get(sidebarStateAtom);
        if (value) {
            set(sidebarStateAtom, SidebarState.LEFT_SIDEBAR);
        } else if (currentState === SidebarState.LEFT_SIDEBAR) {
            set(sidebarStateAtom, SidebarState.CLOSED);
        }
    },
);

export const rightDrawerOpenAtom = atom(
    (get) => get(sidebarStateAtom) === SidebarState.RIGHT_DRAWER,
    (get, set, value: boolean) => {
        const currentState = get(sidebarStateAtom);
        if (value) {
            if (currentState !== SidebarState.RIGHT_DRAWER) {
                set(previousSidebarStateAtom, currentState);
            }
            set(sidebarStateAtom, SidebarState.RIGHT_DRAWER);
        } else if (currentState === SidebarState.RIGHT_DRAWER) {
            set(sidebarStateAtom, get(previousSidebarStateAtom));
        }
    },
);
